const FAQ = () => import(/* webpackChunkName: "FAQ" */ '@/components/Pages/FAQ')

module.exports = [
  {
    path: '/:partner?/FAQ',
    name: 'FAQ',
    component: FAQ
  }
]
